/**
 * Founder self-identification answers (UX sheet r113-r115). Mirrors the
 * Backend `SelfIdentificationAnswer` enum. Unanswered is `undefined`/`null`,
 * never a fourth value on the wire.
 */
export const SELF_ID_ANSWERS = ['yes', 'no', 'prefer_not_to_say'] as const;
export type SelfIdAnswer = (typeof SELF_ID_ANSWERS)[number];

/**
 * The one label lookup for a self-identification answer, form and read-only
 * views alike. `unanswered` covers a question the founder skipped.
 */
export const SELF_ID_ANSWER_LABEL: Record<SelfIdAnswer | 'unanswered', string> = {
  yes: 'Yes',
  no: 'No',
  prefer_not_to_say: 'Would rather not say',
  unanswered: 'Not provided',
};
